import { createContext, useContext, useState } from 'react'
import { BreadcrumbObjectType } from '../generated/apollo-operations'
import { Breadcrumb, useBuildBreadcrumbs } from '../utils/breadcrumbs'

const BreadcrumbsContext = createContext<{
  breadcrumbs: Breadcrumb[]
  loading: boolean
  objectType?: BreadcrumbObjectType
  setDynamicFinalBreadcrumbName: (name: string) => void
} | null>(null)

export const BreadcrumbsProvider = ({ children }: { children: React.ReactNode }) => {
  const [dynamicFinalBreadcrumbName, setDynamicFinalBreadcrumbName] = useState<string | undefined>(
    undefined,
  )
  const { breadcrumbs, loading } = useBuildBreadcrumbs(dynamicFinalBreadcrumbName)

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, loading, setDynamicFinalBreadcrumbName }}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export const useBreadcrumbs = () => {
  const context = useContext(BreadcrumbsContext)
  if (!context) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider')
  }
  return context
}
